/**
 * Severity-override copy shared by the single-alert modal
 * (`AlertSeverityOverrideCell`) and the bulk modal (`bulkActionCopy`).
 */

/**
 * What an override reaches. Update it, and the Alerts docs page, when KIR-5205
 * makes filters, sorting and dashboards use the overridden severity.
 */
export const SEVERITY_OVERRIDE_REACH =
  'The updated severity will also apply to any future matching alerts and is used for notification preferences and endpoint alerts. Dashboards, filters and sorting still use the original severity.';
